module.exports = __webpack_public_path__ + "media/images/smart_phone/icons/my_catalog_order_index-753d4c9d25629a8bdf5aebef2bc1611b.png";